
export const HERO_CONTENT = `I’m a third-year B.Tech student in Computer Science (Artificial Intelligence) at Indira Gandhi Delhi Technical University for Women. I enjoy turning ideas into clean, thoughtful digital experiences and continuously growing as a developer through learning and hands-on building.`;

export const ABOUT_TEXT = `I’m working towards becoming a Full Stack Developer with a strong interest in building clean, scalable, and user-friendly web applications. I’m gradually expanding my skills by learning modern frameworks and tools. I enjoy solving problems through code and creating digital experiences that feel simple, reliable, and thoughtfully designed.`;

export const EXPERIENCES = [
  {
    year: "Sep 2024 – Apr 2025",
    role: "Research Intern",
    company: "AI Research Team, ACM Student Chapter, IGDTUW",
    description: `
Co-authored a research paper titled "Exploring AI-Enabled Tools for Research Writing: 
A Systematic Review", featured in the ACM IGDTUW magazine. 
Selected among top applicants and awarded a Certificate of Outstanding Performance 
for exceptional research contributions.
    `,
    skills: ["AI Research", "Literature Review", "Technical Writing"],
  },

   {
    year: "2025 – Present",
    role: "General Secretary",
    company: "IEEE IGDTUW",
    description: `
Responsible for coordinating technical and organizational initiatives of IEEE IGDTUW.
Facilitating collaboration between teams, managing workflows, and ensuring smooth
execution of events and projects.
    `,
    skills: ["Leadership", "Team Coordination", "Project Management"],
  },
 {
    year: "2025",
    role: "DSA Mentor",
    company: "Techneeds IGDTUW",
    description: `
Mentoring juniors in Data Structures and Algorithms while actively enhancing
problem-solving skills through collaborative learning and guided practice.
    `,
    skills: ["Data Structures", "Algorithms", "Mentoring", "Problem Solving"],
  },
 
  
];


export const CONTACT = {
  email: "anushree025btcseai23@igdtuw.ac.in",
};